@if (showModal$ | async; as show) {
<atx-modal
  [show]="show"
  [showCloseBtn]="false"
  [closeOnOutside]="true"
  (modalClose)="closeModal()"
>
  <button
    type="button"
    class="close btn btn-round close_btn"
    data-dismiss="modal"
    aria-label="Close"
    (click)="closeModal()"
  >
    <fa-icon [icon]="['fas', 'xmark']"></fa-icon>
  </button>

  <div class="d-flex flex-column justify-content-between content-wrapper">
    @if (vm$ | async; as vm) {
    <div class="position-relative">
      @if (vm.title) {
      <div class="text-center px-5 py-2 title w-100">
        <span>{{ vm.title }}</span>
      </div>
      } @if (vm.media) {
      <atx-media-preview [media]="vm.media" [videoAttributes]="videoAttributes">
      </atx-media-preview>
      }
    </div>

    @if (vm.description) {
    <span class="text-center px-4 my-1">{{ vm.description }}</span>
    }

    <button
      class="my-2 mx-auto btn btn-primary see-more-btn"
      (click)="seeMore(vm.listReference)"
    >
      See more
    </button>
    }
  </div>
</atx-modal>
}
